import api from '../apis/constants';
import { HomeConfig, HomeConfigFormData } from '../types/home';

const homeService = {
  /**
   * Get home page configuration
   * @returns Promise with home configuration data
   */
  getHomeConfig: async (): Promise<HomeConfig> => {
    try {
      const response = await api.get('/home');
      return response.data;
    } catch (error) {
      console.error('Error fetching home config:', error);
      throw error;
    }
  },

  /**
   * Update home page configuration
   * @param data Home configuration data to update
   * @returns Promise with updated home configuration data
   */
  updateHomeConfig: async (data: HomeConfigFormData): Promise<HomeConfig> => {
    try {
      const response = await api.put('/home', data);
      return response.data;
    } catch (error) {
      console.error('Error updating home config:', error);
      throw error;
    }
  }
};

export default homeService; 